<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row align-items-center mb-md-4">
            <div class="col-md-4">
              <h2 class="page-title mb-md-0 mb-3">
                <a v-on:click="$router.go(-1)"
                  ><img
                    src="/images/back-arrow.svg"
                    width="20"
                    alt=""
                    class="me-2 cursor-pointer"
                /></a>
                Membership Plans
              </h2>
            </div>
            <div class="col-md-8 form-style d-flex justify-content-end"></div>
          </div>
          <div class="row">
            <div
              class="col-md-4"
              v-for="(data, index) in list"
              :key="index"
              :value="data.uuid">
              <div class="card plan-card">
                <div
                  class="card-header text-center"
                  style="height: 240px"
                  :style="
                    data.is_membership_subscribed == 'Y'
                      ? 'background-color: #BD1C9C'
                      : ''
                  ">
                  <div class="align-wrap">
                    <div class="mt-2">
                      <p
                        class="font-bold text-uppercase"
                        style="margin-top: 1rem">
                        {{ data.name }}
                      </p>
                      <h3 class="font-bold">₹{{ data.fee }}</h3>
                    </div>
                    <div
                      v-if="data.is_membership_subscribed == 'Y'"
                      class="d-flex justify-content-between">
                      <p class="mb-2 font-14">Start Date</p>
                      <p class="mb-0 font-14">
                        {{
                          data.membership_start_date
                            ? $helperService.getFormatedDate(
                                data.membership_start_date
                              )
                            : ""
                        }}
                      </p>
                    </div>
                    <div v-else class="d-flex justify-content-between"></div>
                    <div
                      v-if="data.is_membership_subscribed == 'Y'"
                      class="d-flex justify-content-between">
                      <p class="mb-2 font-14">End Date</p>
                      <p class="mb-0 font-14">
                        {{
                          data.membership_end_date
                            ? $helperService.getFormatedDate(
                                data.membership_end_date
                              )
                            : ""
                        }}
                      </p>
                    </div>
                    <h5 class="font-bold">
                      Validity In Days - {{ data.validity_in_days }}
                    </h5>
                    <h5 class="font-bold">
                      Max Contact Views - {{ data.max_contact_views_count }}
                    </h5>
                  </div>
                </div>
                <div class="card-body px-lg-2">
                  <p
                    class="d-flex mb-2"
                    style="overflow-y: scroll; height: 280px">
                    <span class="me-1">
                      <!-- <i class="fa fa-check-circle" aria-hidden="true"></i
                    > -->
                    </span>

                    <span v-html="data.description"></span>
                  </p>

                  <button
                    v-if="data.fee > currPlanAmt && !data.is_offline"
                    :id="'save-button_' + index"
                    v-on:click="buyPlan(data.uuid, index, data.fee)"
                    class="btn btn-brand-1 w-100 mt-4">
                    {{
                      is_membership_subscribed == "Y"
                        ? "Upgrade Plan"
                        : "Buy Now"
                    }}
                  </button>
                  <button
                    v-if="data.is_membership_subscribed == 'Y'"
                    class="btn btn-brand-1 w-100 mt-4">
                    Current Plan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row mx-0 mb-4">
          <div class="col-lg-12 mt-5 text-end">
            <div class="page-bottom-pagination">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange"
                ref="listPagination" />
            </div>
          </div>
        </div> -->
        <ErrorComponent @retry="getList(0)" ref="errorComponent" />
      </div>
    </main>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
// import Pagination from "@/components/Pagination";
export default {
  name: "MembershipPlans",
  components: {
    ErrorComponent,
    // Pagination,
  },
  data() {
    return {
      loader: false,
      is_membership_subscribed: false,
      offset: -1,
      keyword: "",
      currPlanAmt: 0,
      count: "",
      searchObj: {},
      detail: {},
      counts: {},
      list: [],
    };
  },
  mounted() {
    this.moveToContacat();
    this.getDetail();
  },
  methods: {
    moveToContacat() {
      this.$refs.errorComponent.updateFormLoader(true);
      if (window.location.pathname == "/membership-plans") {
        window.scrollTo(0, 0);
      }
    },
    buyPlan(uuid, index) {
      var type = "NORMAL";
      var user_detail = this.$store.getters.getUser;
      if (this.is_membership_subscribed == "Y") {
        type = "UPGRADE";
      }
      const win = window.open(
        this.$api.getBaseUrl() +
          "ccavenue/init-payment?plan_id=" +
          uuid +
          "&user_id=" +
          user_detail.uuid +
          "&type=" +
          type,
        "mywindow",
        "menubar=1,resizable=1,width=1200,height=700"
      );

      const timer = setInterval(() => {
        if (win.closed) {
          localStorage.setItem("is_membership_subscribed", "Y");
          window.location.reload();
          clearInterval(timer);
        }
      }, 500);
      if ((uuid, index)) {
        // var obj = {};
        // obj.plan_id = uuid;
        // this.$api
        //   .postAPI({
        //     _action: "/buy-new-plan",
        //     _body: obj,
        //     _buttonId: "save-button_" + index,
        //   })
        //   .then((res) => {
        //     this.$notify({
        //       type: "success",
        //       text: res.message,
        //     });
        //     // document.getElementById("subFoter").style.display = 'none';
        //   })
        //   .catch(() => {});
      }
    },
    getDetail() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.detail = res;
          if (res.is_membership_subscribed) {
            localStorage.setItem(
              "is_membership_subscribed",
              res.is_membership_subscribed
            );
            this.is_membership_subscribed = res.is_membership_subscribed;
            if (res.membership_plan && res.membership_plan.subscription_plan) {
              this.currPlanAmt = res.membership_plan.subscription_plan.fee;
            }
          } else {
            localStorage.setItem("is_membership_subscribed", "N");
          }
          this.getList(0);
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(offset, orderBy, sortBy) {
      this.$refs.errorComponent.updateFormLoader(true);
      this.loader = true;
      this.list = [];
      this.searchObj.offset = offset;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/subscription-plan/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.count = res.count;
          this.offset = res.next_offset;
          var array = [];
          for (var i in res.list) {
            res.list[i].is_membership_subscribed = "N";
            res.list[i].membership_start_date = null;
            res.list[i].membership_end_date = null;
            if (this.detail && this.detail.membership_plan) {
              if (this.detail.membership_plan.plan_id == res.list[i].uuid) {
                res.list[i].is_membership_subscribed = "Y";
                res.list[i].membership_start_date =
                  this.detail.membership_start_date;
                res.list[i].membership_end_date =
                  this.detail.membership_end_date;
                array.push(res.list[i]);
              } else if (res.list[i].status == "ACTIVE") {
                array.push(res.list[i]);
              }
            } else {
              if (res.list[i].status == "ACTIVE") {
                array.push(res.list[i]);
              }
            }
          }

          this.list = array;
          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "Membership Plan Not Available"
            );
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined);
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
  },
};
</script>
